export default __webpack_public_path__ + "static/media/sd.191943a3.png";